// 编辑权限组页面
<template>
    <div>
        <div class="box">
            <p class="return" @click="back">返回首页</p>
            <span class="line">|</span>
            <p class="contract">系统设置</p>
            <span class="lines">></span>
            <p class="contract back" @click='$router.go(-1)'>权限组管理</p>
            <span class="lines">></span>
            <p class="contract" v-if="edit">编辑权限组</p>
        </div>
        <div class="p_btn">
            <div>
                <div class="mainTitle" v-if="edit">编辑权限组</div>
            </div>
        </div>

        <div class="dataitems" v-if="edit">
            <el-form label-width="100px" ref="editInfo" :model="editInfo" :rules="ruless" label-position="right">
                <div class="item">
                    <el-form-item label="权限组名称" prop="name">
                        <el-input v-model="editInfo.name" maxlength="10"></el-input>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <div class="contree">
            <div class="trees">
                <div class="table">
                    <h4>页面权限</h4>
                </div>
                <div class="gettree">
                    <div class='mytree'>
                        <div class='first'>嗖嗖人力服务平台</div>
                        <el-tree
                                ref="tree"
                                :default-checked-keys="defaultLists"
                                :default-expanded-keys="defaultLists"
                                :props="propsa"
                                :data="data"
                                :indent='0'
                                node-key="id"
                                @check="checkAllTree"
                                show-checkbox
                                @node-click="handleCheckon"
                                @check-change="handleCheckChange">
               <span class="custom-tree-node" slot-scope="{ node, data }">
                 <span>
              <i v-if='data.type==1'>
	        <img src="../../../assets/img/shezhi.png"></img>
                
              </i>
               <i v-if='data.type==2'>
	        <img src="../../../assets/img/shezhi1.png"></img>
                
              </i>
              {{data.name}}
                 </span>              
           </span>
                        </el-tree>

                    </div>

                </div>

            </div>
            <div class="edit">
                <div class="table">
                    <h4>操作权限</h4>
                </div>


                <div class="edut">
                    <div class="fontName">{{operationName}}</div>
                    <el-checkbox-group v-model="checkOne" class="checkGroup">
                        <el-checkbox v-for="(v,k) in operation"
                                     :label="v.id"
                                     :key="k"
                                     @change="handleCheckedCitiesChange($event,v.id)">
                            {{v.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>

            </div>

        </div>
        <div class="btndiv">
            <button class="btn" type="button" @click='$router.go(-1)' tag="button">取消</button>
            <button class="btn subbtn" @click="addOrg" type="button">保存</button>
        </div>

    </div>
</template>

<script>
    export default {
        created() {
            this.edit = this.$route.query.edit;
            //初始化数据
            this.loadData()
            //this.loadDataPandO()
            if (this.$route.query.id) {
                this.loadEiditPermission()

            }
        },
        data() {
            return {
                checks: false,
                detailList:[],
                checkk: [],
                cheks: false,
                choseYes: false,
                listidss: [],
                permissionList: [],
                defaultLists: [],
                listIds: [],
                editInfo: {
                    name: ''
                },
                operationName: '',
                data: [],
                operation: [],
                checkOne: [],
                propsa: {
                    label: 'name',
                    value: 'id',
                    children: 'children',
                },
                props: {
                    label: 'label',
                    value: 'id',
                    children: 'children',
                },
                edit: false,
                orgList: [],
                baseInfo: {
                    name: '',
                    mobile: '',
                    email: '',
                    orgId: '',
                    authority: 1,
                },
                ruless: {
                    name: [{
                        required: true,
                        message: "请输入权限组名称",
                        trigger: "blur"
                    }],

                },

                rules: {
                    name: [{
                        required: true,
                        message: "请输入权限组名称",
                        trigger: "blur"
                    }],

                }

            }

        },
        methods: {
            back() {
                this.$router.push({path: '/main'})

            },
  
               detailTrees(data,values) {
               // let detailList = []
                for (var key in data) {
                if (data[key].children.length > 0) {
                    this.detailTrees(data[key].children,values)
                }else {
                this.detailList.push(data[key].id)

                }
            }
                 let arr = []
                                let parentArr = this.$refs.tree.getHalfCheckedKeys()
                                    for(let j of this.detailList) {
                                         for(let i of values) {
                                       if(i == j) {
                                        arr.push(+i)
                                    }
                                    }
                                  
                                }                   
                            this.permissionList = values;
                            this.defaultLists = arr
            },


            loadEiditPermission() {
                const params = {
                    id: this.$route.query.id
                };
                return this.$axios.get("/permissionGroup/findPermissionGroupById?id=" + this.$route.query.id)
                    .then(res => {
                        if (res.data.status == 1) {
                           
                            this.detailTrees(this.data,res.data.data.values)
                          

                           
                            this.editInfo = {
                                name: res.data.data.name,
                            };
                        }
                    });
            },


            checkAllTree(data, list) {
                this.choseYes = true
                 // this.listIds = list.checkedNodes

        let parentArr = this.$refs.tree.getHalfCheckedKeys();
      let childeArr = this.$refs.tree.getCheckedKeys();
      let arr = childeArr.concat(parentArr);
      this.listIds = arr;

            },
            //保存

            addOrg() {
                this.listidss = []
                if (this.choseYes == true || this.checks == true) {
                       let parentArr = this.$refs.tree.getHalfCheckedKeys();
                       let childeArr = this.$refs.tree.getCheckedKeys();
                       let arr = childeArr.concat(parentArr);
                       this.listIds = arr;
                    if(this.listIds.length >0){
                        for (let i of this.listIds) {
                            this.listidss.push(i)
                        }
                    }else if(this.listIds.length==0){
                        this.listidss ==[]

                    }else {
                        for (let i of this.defaultLists.values()) {
                            this.listidss.push(i)
                        }
                    }
                    for (let j of this.checkOne.values()) {
                        this.listidss.push(j)
                    }
                } else {
                    this.listidss = this.permissionList
                }
                 if (this.edit) {

                    this.$refs.editInfo.validate(status => {
                        if (status == true) {
                            return this.$axios.post('permissionGroup/editPermissionGroup?name=' + this.editInfo.name + '&values=' + this.listidss + '&id=' + this.$route.query.id).then(res => {
                                if (res.data.status == 1) {
                                    this.$message.success(res.data.message);
                                    this.$router.push({path: '/main/system/system/rightsGroups'})

                                } else {

                                    this.$message.error(res.data.message);
                                }
                            }).catch(err => {
                                //处理错误
                                this.maskshow = false;
                                console.error(err)
                            })
                        }
                    })
                }
            },


            handleCheckedCitiesChange(data,id) {
                this.cheks = true
                // this.checkOne = this.checkOne.map(res => {
                //     if (res != this.actionid) {
                //         return res;
                //     }
                // });
            },
            handleCheckChange(data, checked, indeterminate) {


               
            },
            handleNodeClick(data) {
            },
            handleCheckon(data) {
                this.operationName = data.name

                this.checks = true

                //查询某一个权限
                this.$axios.get(`/permission/findByParentId?parentId=`+ data.id +`&type=`+this.$route.query.type).then(res => {
                    if (res.data.status === 1) {
                        this.operation = res.data.data
                        for (var i = 0; i < this.permissionList.length; i++) {
                            for (var j = 0; j < this.operation.length; j++) {
                                if (this.permissionList[i] == this.operation[j].id) {
                                    this.checkk = []
                                    this.checkk.push(this.permissionList[i])
                                    this.checkOne.push(+this.permissionList[i])
                                }
                            }
                        }

                    } else {
                        this.$message.error('查询组织列表请求失败');
                    }
                }).catch(err => {
                    console.log(err)
                })


            },

            loadDataPandO() {
                //查询组织列表
                this.$axios.get('/org/tree').then(res => {
                    if (res.data.status === 1) {
                        this.orgList = res.data.data;
                    } else {
                        this.$message.error('查询组织列表请求失败');
                    }
                }).catch(err => {
                    console.log(err)
                })
            },

            // 加载树列表
            loadData() {
                return this.$axios.get('permission/getPermissionTree').then(res => {
                    this.data = res.data.data;

                    this.total = res.data.data.total;
                }).catch(err => {
                    //处理错误
                    console.error(err)
                })
            },


        },

    }
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
    .box {
        display: flex;
        margin-top: 20px;

        .return {
            font-size: 12px;
            font-weight: 400;
            color: rgba(102, 105, 227, 1);
            margin-right: 20px;
            cursor: pointer;
        }

        .line {
            margin-right: 20px;
            color: #606266
        }

        .lines {
            margin-right: 20px;
            color: #606266;
            font-weight: bold;
        }

        .back:hover {
            color: #6669e3;
            cursor: pointer
        }

        .contract {
            margin-right: 20px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(138, 138, 154, 1);
        }
    }

    .mainTitle {
        font-size: 24px;
        font-weight: bold;
        color: rgba(48, 49, 64, 1);
        margin: 33px 0 14px 0;
    }

    .dataitems {
        width: 55%;
        // padding-left: 12%;
    }

    .contree {
        width: 100%;
        height: 740px;
        border-radius: 4px;
        border: 1px solid rgba(216, 218, 225, 1);
        display: flex

    }

    .trees {
        width: 50%;
        height: 700px;
        overflow-y: auto;
        overflow-x: hidden;
        border-right: 1px solid #D8DAE1;
    }

    .edit {
        width: 50%;
        height: 740px;
        background: rgba(247, 248, 252, 1);
    }

    .table {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 20px 34px;

        h4 {
            font-size: 14px;
            font-weight: bold;
            position: relative;
            display: flex;
            align-items: center;
            padding-left: 8px;
            color: #303140;
        }

        h4:before {
            content: "";
            position: absolute;
            left: 0;
            display: block;
            width: 4px;
            height: 12px;
            background-color: #6669e3;
            border-radius: 4px;
        }

    }

    .gettree {
        margin-left: 34px
    }

    .mytree {
        margin-left: 10px;

        .first {
            margin-left: 10px;
            font-size: 12px;
            font-weight: bold;
            color: rgba(84, 85, 102, 1);
        }
    }

    .mytree[data-v-e8abc770] .el-tree .el-tree-node:before {
        border-left: 0px solid #D8DAE1;
        bottom: 0px;
        height: 100%;
        top: -17px;
        width: 1px;
    }

    .mytree /deep/ .el-tree {
        > .is-current:after {

            background-color: transparent;
        }

        .el-tree > .is-current:after {

            background-color: transparent;
        }

        .el-tree > .el-tree-node:after {
            border-top: none;
            background-color: #eee;

        }

        .el-tree-node {
            position: relative;
            padding-left: 16px;
        }

        //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
        .el-tree-node__expand-icon.is-leaf {
            display: none;
        }

        .el-tree-node__children {
            padding-left: 16px;
        }

        .el-tree-node :last-child:before {
            height: 38px;
        }

        .el-tree > .el-tree-node:before {
            border-left: none;
        }

        .el-tree > .el-tree-node:after {
            border-top: none;
        }

        .el-tree-node:before {
            content: "";
            left: -4px;
            position: absolute;
            right: auto;
            border-width: 1px;
        }

        .el-tree-node:after {
            content: "";
            left: -4px;
            position: absolute;
            right: auto;
            border-width: 1px;
        }

        .el-tree-node:before {
            border-left: 1px solid #D8DAE1;
            bottom: 0px;
            height: 100%;
            top: -17px;
            width: 1px;
        }

        .el-tree-node:after {
            border-top: 1px solid #D8DAE1;
            height: 20px;
            top: 21px;
            width: 24px;
        }

        .el-tree .is-current:after {

            background-color: transparent;
        }
    }

    .edut {
        margin-left: 40px;

        .fontName {
            font-size: 12px;
            font-weight: bold;
            color: rgba(84, 85, 102, 1);
            margin-bottom: 20px;

        }
    }

    .btndiv {
        display: flex;
        justify-content: center;
        margin: 20px 0;

        .subbtn {
            margin-left: 10px;
        }
    }
</style>
